<template>
	<div class="newRulesDetails">
		<el-form label-width='100px' class="qcFrom editFroms contentBigBox" ref="rulesFrom" :rules="rules" :model="rulesFrom" v-loading="loading">
			<el-row>
				<el-form-item label="状态">
					<div class="exportTab marr20">
						<div class="sliderScreeningR">
							<a href="javascript:;" @click="seachTab(true)" :class="rulesFrom.Enable?'active':''">启用</a>
							<a href="javascript:;" @click="seachTab(false)" :class="!rulesFrom.Enable?'active':''">禁用</a>
						</div>
					</div>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="错误类型" required>
					<el-col>
						<el-radio-group v-model="rulesFrom.IsSpecial" @change="isSpecialChange">
							<el-radio :label="false">普通</el-radio>
							<el-radio :label="true">严重</el-radio>
						</el-radio-group>
					</el-col>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="设备" prop="modalityType">
					<el-checkbox-group v-model="rulesFrom.modalityType">
						<el-checkbox v-for="item in detailsRulesParameter.modalityType" :key="item.text" :label="item.text">{{item.text}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="适用类型" prop="type">
					<el-select size="small" @change="changeType" v-model="rulesFrom.type" placeholder="请选择类型">
						<el-option v-for="item in detailsRulesParameter.type" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模式" prop="mode" v-if="!rulesFrom.IsSpecial">
					<el-select size="small" v-model="rulesFrom.mode" placeholder="请选择模式">
						<el-option v-for="item in detailsRulesParameter.mode" :key="item.value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="描述" prop="description">
					<el-input size="small" class="width300" v-model="rulesFrom.description" placeholder="请输入描述" type="textarea" :rows="3"></el-input>
				</el-form-item>
			</el-row>
			<el-row>
				<el-form-item label="分值" prop="score">
					<el-input size="small" class="width300" v-model.number="rulesFrom.score" :disabled="rulesFrom.IsSpecial" placeholder="请输入分值"></el-input>
				</el-form-item>
				<el-form-item label="类别" prop="CategoryId">
					<el-select size="small" v-model="rulesFrom.CategoryId" placeholder="请选择类别">
						<el-option v-for="item in dictionaryList" :key="item.UniqueId" :label="item.Value" :value="item.UniqueId"></el-option>
					</el-select>
				</el-form-item>
			</el-row>

			<el-row v-if="!rulesFrom.IsSpecial">
				<el-form-item label="严重扣分">
					<el-input size="small" class="width300" v-model.number="rulesFrom.SeriousScore" placeholder="请输入分值"></el-input>
				</el-form-item>
			</el-row>

			<el-row>
				<el-form-item label="备注">
					<el-input size="small" class="width300" v-model="rulesFrom.remark" placeholder="请输入备注" type="textarea" :rows="2"></el-input>
				</el-form-item>
			</el-row>
			<!-- <el-row v-if="!rulesFrom.IsSpecial">
				<el-form-item label="细则选项">
					<el-checkbox :disabled="rulesFrom.edit" v-model="rulesFrom.HasOption" @change="changeHasOption"></el-checkbox>
				</el-form-item>
			</el-row> -->
			<el-row class="table marl100">
				<el-col :span='18' ref="sortableContainer" v-if='rulesFrom.HasOption'>
				<el-table class="qcTable distributionTable" :data="rulesFrom.OptionList" row-key="localityid">
					<el-table-column label="名称" min-width="120">
						<template slot-scope="scope">
							<el-input v-model="scope.row.Description"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="Score" label="分值" min-width="100">
						<template slot-scope="scope">
							<el-input min="0" type="number" v-model.number="scope.row.Score" @blur="scoreChange(scope.row)"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="Remark" label="备注">
						<template slot-scope="scope">
							<el-input v-model="scope.row.Remark" placeholder="请输入备注"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='left' width="180">
						<template slot-scope="scope">
							<span class="table-task-btn delete" v-if="scope.$index != 0" @click="remove(scope.$index)">删除</span>
							<span class="table-task-btn detail" @click="add">新增</span>
							<span style="cursor: move;" class="handle-icon" @mousedown.stop>&#9776;</span>
						</template>
					</el-table-column>
				</el-table>
				</el-col>
			</el-row>
			<el-row>
				<el-form-item>
					<el-button type="primary" class="mart40" @click="onSubmit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import Sortable from 'sortablejs'
	import draggable from 'vuedraggable';
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		components: {
			draggable,
		},
		data() {
			return {

				rules: {
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],
					modalityType: [{
						type: 'array',
						required: true,
						message: '请至少选择一种设备',
						trigger: 'change'
					}],
					mode: [{
						required: true,
						message: '请选择模式',
						trigger: 'change'
					}],
					score: [{
							required: true,
							message: '请输入分值',
							trigger: 'blur'
						},
						{
							type: 'number',
							message: '分值必须是数字'
						},
					],
					CategoryId: [{
						required: true,
						message: '请选择类别',
						trigger: 'change'
					}],
					description: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}]

				},

			}
		},
		computed: {
			...Vuex.mapState('managerPlan', ['detailsRulesParameter', 'rulesFrom', 'loading','dictionaryList'])
		},
		created() {
			this.$nextTick(()=>{
				this.GetReportModality()
				this.rowDrop()
			})
		},
		beforeDestroy() {
			if (this.rulesFrom.OptionList) {
				this.rulesFrom.OptionList.destroy();
			}
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['setLoading']),
			...Vuex.mapActions('managerPlan', ['createorupdate','GetDictionary','GetReportModality']),
			changeHasOption(){
				if (this.rulesFrom.HasOption) {
					this.rowDrop()
				}
			},
			rowDrop() {
				const tbody = document.querySelector(".el-table__body-wrapper tbody");
				const _this = this;
				Sortable.create(tbody, {
					animation: 150,
					ghostClass: 'blue-background-class',
					onEnd: evt => {
						let newIndex = evt.newIndex
						let oldIndex = evt.oldIndex
						const currRowdom = tbody.children[newIndex]
						const oldRowdom = tbody.children[oldIndex]
						tbody.removeChild(currRowdom)
						if (newIndex > oldIndex) {
						tbody.insertBefore(currRowdom, oldRowdom)
						} else {
						tbody.insertBefore(currRowdom, oldRowdom.nextSibling)
						}
						const currRow = _this.rulesFrom.OptionList.splice(oldIndex, 1)[0]
						_this.rulesFrom.OptionList.splice(newIndex, 0, currRow)

					}
				});
			},
			isSpecialChange(){
				this.rulesFrom.score = this.rulesFrom.IsSpecial?100:0;
			},
			changeType(){
				let tag = 0;
				if (this.rulesFrom.type == 1) {
					tag = 7;
				}else{
					tag = 6;
				}
				this.GetDictionary({
					tag:tag
				})
			},
			scoreChange(row){
				if (row.Score>this.rulesFrom.score) {
					row.Score = 0;
					this.$message.error('最高分值不能超过设置分值'); 
				}
			},
			add() {
				let obj = {
					OptionGuid: "",
					Description: "",
					Score: "",
					Remark: "",
					localityid:this.uuid()
				}
				this.rulesFrom.OptionList.push(obj)
			},
			remove(index) {
				this.rulesFrom.OptionList.splice(index, 1)
			},
			seachTab(type){
				this.rulesFrom.Enable = type;
			},
			onSubmit(formName) {
				this.$refs.rulesFrom.validate((valid) => {
					this.setLoading(true);
					if(valid) {
						this.createorupdate()
					} else {
						return false;
					}
				});
			},
		}

	}
</script>
<style lang="scss" scoped>
	.table-task-btn{
		width: 33% !important;
	}
</style>